import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { CTAButton } from '../ui/CTAButton';
import { Shield } from 'lucide-react';
export function CTASection() {
  return <section id="comprar" className="py-16 md:py-24 bg-[#FFF8ED] px-4 border-y-2 border-amber-100" data-id="element-74">
      <div className="max-w-3xl mx-auto text-center" data-id="element-75">
        <FadeInSection data-id="element-76">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-77">
            Toma el Control de tu Cuerpo Hoy Mismo
          </h2>

          <p className="text-xl text-gray-700 mb-10 max-w-2xl mx-auto" data-id="element-78">
            No pases un día más sintiéndote agotado y esclavo de tus antojos. La
            solución es simple y está a un clic de distancia.
          </p>

          <div className="bg-white p-8 rounded-3xl shadow-2xl border border-gray-100 max-w-xl mx-auto mb-8" data-id="element-79">
            <div className="inline-block bg-red-600 text-white font-bold text-sm px-4 py-1.5 rounded-full mb-4 uppercase tracking-wide" data-id="element-80">
              Oferta por tiempo limitado — 93% de descuento
            </div>

            <div className="mb-6" data-id="element-81">
              <span className="text-gray-400 line-through text-xl block mb-1" data-id="element-82">
                Precio regular: $97
              </span>
              <div className="flex items-center justify-center gap-3" data-id="element-83">
                <span className="text-6xl font-bold text-green-700" data-id="element-84">$6.39</span>
              </div>
              <p className="text-green-600 font-semibold text-lg mt-2" data-id="element-85">
                Ahorras $90.61 hoy
              </p>
            </div>

            <CTAButton text="Descargar Mi Copia Hoy" href="https://vidaenvirtud.com/checkouts/cn/hWN9XlyUm3yKHzdFngY5YSIr/es-us?_r=AQABzN1_8teYTZbzr_frC28Z0FSGVlo0QN8emiGvq9G792c&auto_redirect=false&edge_redirect=true&skip_shop_pay=true" className="w-full text-2xl py-6 mb-4" data-id="element-86" />

            <div className="flex items-center justify-center text-gray-500 text-sm mt-4" data-id="element-87">
              <Shield className="w-4 h-4 mr-2" data-id="element-88" />
              <span data-id="element-89">Pago 100% Seguro y Encriptado • Garantía de 30 Días</span>
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>;
}